import { render, staticRenderFns } from "./BrandInviteDialog.vue?vue&type=template&id=c078b652"
import script from "./BrandInviteDialog.vue?vue&type=script&lang=js"
export * from "./BrandInviteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports